import styled from "styled-components";

import flocknoteStateHooks from "Flocknote/stateHooks";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTabs from "UI/FnrTabs";

import Info from "../Screens/Info";
import useTabsConfig from "../Screens/useTabsConfig";

import AutoNavigateToLastItemTab from "./AutoNavigateToLastItemTab";
import { useIsNew, useTabKey, useTransitioningToNewItem } from "./statehooks";

export default function EditSignupItemNav() {
  const tabs = useTabsConfig();
  const activeTabKey = useTabKey();
  const isNew = useIsNew();
  const [
    {
      currentSignupList: {
        fundIt: { fund },
      },
      user: { isAdminOfAnyGroup },
    },
  ] = useSignups();

  const [{ hasSignupsProfileFields }] =
    flocknoteStateHooks.useNetworkMetadata();

  const hasFund = fund?.ID > 0;

  const { forceToAddItem, isInCreationFlow } = useNewSignupCreationFlow();
  const transitioningToNewItem = useTransitioningToNewItem();

  let showNavBar = false;
  if (isAdminOfAnyGroup) {
    if (hasFund || hasSignupsProfileFields) showNavBar = true;
    if (!forceToAddItem && !isInCreationFlow && !isNew) showNavBar = true;
  }

  return (
    <>
      <AutoNavigateToLastItemTab
        forceToAddItem={forceToAddItem}
        isAdminOfAnyGroup={isAdminOfAnyGroup}
      />
      <TabsWrapper>
        <FnrTabs
          tabs={tabs}
          activeTabKey={activeTabKey}
          padding={0}
          isLoading={transitioningToNewItem}
          clip={false}
          contentOnly={!showNavBar}
          divider={
            <FnrContainedIcon
              icon="fa-chevron-right fas"
              color="divider"
              size="xs"
            />
          }
        />
      </TabsWrapper>
    </>
  );
}

const TabsWrapper = styled("div")`
  padding-top: 8px;
`;
